'use strict'

const state = {
  routesList: []
}

const getters = {
  getRoutesList (state) {
    return state.routesList
  }
}

const actions = {
  setRoutesList ({commit}, data) {
    commit('setRoutesList', data)
  }
}

const mutations = {
  setRoutesList (state, {routesList}) {
    state.routesList = routesList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
